import { useMediaQuery } from "@uidotdev/usehooks";

export function useIsMobile() {
  return !useMediaQuery("(min-width: 768px)");
}
